class DiamondCustomizations extends HTMLElement {
	static SPECIAL_VARIANTS = ['Special', 'Custom']
	static DEFAULT_VARIANTS = ['Standard', 'Regular']
	static SIZE_NAMES = ['Størrelse', 'Storlek', 'Size']
	static SIZE_PROPERTY_NAME = 'properties[Størrelse]'
	static ENGRAVING_PROPERTY_NAME = 'properties[Indgravering]'
	static ENGRAVING_FONT_PROPERTY_NAME = 'properties[Skrifttype]'
	static DESIGN_ADJUSTMENTS_PROPERTY_NAME = 'properties[Justeringer]'
	static DEBUG = false
	constructor() {
		super()
		this.upgradeOptionName = this.getAttribute('data-upgrade-option-name')
		this.productId = undefined
		this.productData = undefined
		this.variants = []
		this.metal = {
			value: undefined,
			price: 0,
		}
		this.diamond = {
			value: undefined,
			price: 0,
		}
		this.delivery = {
			value: undefined,
			price: 0,
		}
		this.gift = {
			value: undefined,
			price: 0,
		}
		this.engraving = {
			value: undefined,
			price: 0,
			font: undefined,
		}
		this.design_adjustments = {
			value: undefined,
			price: 0,
			// Selected (non-standard) option per adjustment, keyed by the radio group name
			selections: {},
			// Variant keywords of the selected adjustments, used to find the matching special variant
			keywords: [],
			// The selected adjustments without a variant keyword, as those are already part of the variant title
			propertyValue: undefined,
		}
		this.selectedVariant = undefined
		this.selectedVariant = undefined

		this.upgradeOptionsIndex = 1
		this.upgradeOptionIsSizeSelector = true
		this.abortController = new AbortController()

		// Store the bound handler for cleanup
		this.variantUpdateHandler = (_, data) => {
			// Only handle if this is for our product
			if (data.product && data.product.id.toString() !== this.productId)
				return
			const size = data.variant.options[this.upgradeOptionsIndex]?.trim()
			if (size && /^\d+$/.test(size)) {
				this.size = size
			}
			if (DiamondCustomizations.DEBUG) {
				console.info('[Customizations] - variantUpdateHandler', data)
			}
			this.customizationChanged({
				default_variant: data.variant,
			})
		}

		jQuery(window).on('cc-variant-updated', this.variantUpdateHandler)
	}

	getSizeSelectors() {
		return (
			document.querySelector('[data-customization-options]') ||
			document.querySelector(
				`[data-option-index="${this.upgradeOptionsIndex}"]`,
			)
		)
	}

	getUpgradeSelectors() {
		return document.querySelector(
			`.option-selector[data-option-index="${this.upgradeOptionsIndex}"]`,
		)
	}

	connectedCallback() {
		this.productId = this.getAttribute('data-product-id')
		this.upgradeOptionName = this.getAttribute('data-upgrade-option-name')

		this.productData = JSON.parse(
			document.getElementById('ProductJson-' + this.productId).innerHTML,
		)

		// We check in reverse, to find the options that are most likely to be the upgrade option
		for (let i = this.productData.options.length - 1; i >= 0; i--) {
			if (this.upgradeOptionName.includes(this.productData.options[i])) {
				this.upgradeOptionsIndex = i
				if(!DiamondCustomizations.SIZE_NAMES.includes(this.productData.options[i])){
					this.upgradeOptionIsSizeSelector = false
				}
				break
			}
		}

		// Initialize size
		const sizeSelectors = this.getSizeSelectors()
		if (sizeSelectors?.querySelector('.cc-select__btn')) {
			// Dropdowns
			this.size = sizeSelectors
				.querySelector('.cc-select__btn')
				?.textContent?.trim()
		} else if (sizeSelectors) {
			// Radio buttons
			this.size = sizeSelectors
				.querySelector('input:checked')
				?.value?.trim()
		} else {
			this.size = undefined
		}

		this.variants = this.productData.variants || []

		// the "variants" field outputted by {{ product | json }} no longer contain the field 'inventory_quantity'
		// therefore we enrich the variants with this information by merging it with info from the variant table
		this.variants = this.variants.map((v) => {
			const variantData = JSON.parse(
				document.getElementById('VariantJson-' + v.id).innerHTML,
			)
			return {
				...v,
				...variantData,
			}
		})
		// Add form submission handling for customization forms
		this.setupCustomizationFormHandlers()

		this.querySelectorAll('[data-customization-actions]').forEach(
			(action) => {
				const customizationType = action.getAttribute(
					'data-customization-actions',
				)
				if (!this[customizationType]) {
					console.warn(
						`Customization type "${customizationType}" is not defined in the component.`,
					)
					return
				}
				const resetButton = action.querySelector(
					'button[type="button"]',
				)
				if (resetButton) {
					resetButton.addEventListener('click', (e) => {
						if (e.target.closest('[data-edit]')) return
						this.resetCustomization(customizationType)
					})
				}
			},
		)

		document.addEventListener(
			'cc:modal:open',
			(event) => {
				const modal = event.detail.modal
				if (!modal) return
				const confirmationModal = modal.querySelector(
					'.product-confirmation-modal',
				)
				if (!confirmationModal) return
				this.handleConfirmationModalOpen(confirmationModal)
			},
			{ signal: this.abortController.signal },
		)

		// Check the initial variant, if it is one of the special variants, reset to the first available regular variant by clicking the first available option
		setTimeout(() => {
			const urlParams = new URLSearchParams(window.location.search)
			const variantId = urlParams.get('variant')
			if (variantId) {
				const variant = this.variants.find(
					(v) => v.id === parseInt(variantId),
				)
				if (
					variant &&
					DiamondCustomizations.SPECIAL_VARIANTS.some((special) =>
						variant.options[this.upgradeOptionsIndex]?.includes(
							special,
						),
					)
				) {
					// Reset to the first available regular variant
					this.getUpgradeSelectors()
						?.querySelector(`input:not(:disabled)`)
						?.click()
				}
			}
		})
		this.customizationChanged() // Initial call to set up the component state
	}

	showUpgradeComponent() {
		this.classList.remove('hidden')
	}

	hideUpgradeComponent() {
		this.classList.add('hidden')
	}

	hasVisibleCustomizationOptions() {
		return Array.from(
			this.querySelectorAll('[data-customization-actions]'),
		).some((row) => !row.classList.contains('!hidden'))
	}

	updateComponentVisibility() {
		if (this.hasVisibleCustomizationOptions()) {
			this.showUpgradeComponent()
		} else {
			this.hideUpgradeComponent()
		}
	}

	disconnectedCallback() {
		// Abort all event listeners using AbortController
		this.abortController.abort()

		// Remove the specific jQuery event listener for this instance
		if (window.jQuery && this.variantUpdateHandler) {
			jQuery(window).off('cc-variant-updated', this.variantUpdateHandler)
		}
	}
	setupCustomizationFormHandlers() {
		// Use event delegation to handle form submissions for forms that might be dynamically added
		document.addEventListener(
			'submit',
			(event) => {
				const form = event.target
				if (form.matches('form[data-customization-form]')) {
					// Check if this form is related to this product
					const formProductId = form.getAttribute('data-product-id')
					if (formProductId === this.productId) {
						event.preventDefault()
						this.handleCustomizationFormSubmit(form)
					}
				}
			},
			{ signal: this.abortController.signal },
		)

		// Update the adjustment availability while picking, so two variant-based adjustments can't be combined
		document.addEventListener(
			'change',
			(event) => {
				const form = event.target.closest?.(
					'form[data-customization-form="design_adjustments"]',
				)
				if (form?.getAttribute('data-product-id') !== this.productId)
					return
				this.updateDesignAdjustmentAvailability(
					form,
					this.getDesignAdjustmentSelections(form).selections,
				)
			},
			{ signal: this.abortController.signal },
		)

		document.addEventListener(
			'click',
			(event) => {
				if (!(event.target instanceof HTMLElement)) return
				if (!event.target.closest('.cc-modal-window__background'))
					return
				const modal = event.target.closest('.cc-modal-window')
				if (!modal) return
				const form = modal.querySelector(
					'form[data-customization-form]',
				)
				if (!form) return
				const formProductId = form.getAttribute('data-product-id')
				if (formProductId === this.productId) {
					event.preventDefault()
					this.handleCustomizationFormSubmit(form)
				}
			},
			{ signal: this.abortController.signal },
		)
	}

	handleCustomizationFormSubmit(form) {
		const customizationType = form.getAttribute('data-customization-form')

		// Find the selected input in the form
		const selectedInputs = Array.from(
			form.querySelectorAll(
				'input[type="radio"]:checked,input[type="hidden"]',
			),
		)
		const textArea = form.querySelector('textarea')
		const isEngravingForm = !!textArea
		if (selectedInputs.length === 0)
			return console.warn('No customization option selected in the form.')

		const value = isEngravingForm
			? textArea.value
			: selectedInputs
					.filter(
						(input) =>
							!input.value.toLowerCase().includes('standard'),
					)
					.map((input) => input.value)
					.join(', ')

		const price = selectedInputs
			.map((input) => parseFloat(input.dataset.price) || 0)
			.reduce((acc, price) => acc + price, 0)
		const isStandard = textArea ? false : !value

		if (!this[customizationType]) {
			console.warn(
				`Customization type "${customizationType}" is not defined in the component.`,
			)
			return
		}

		// Set the appropriate customization based on the form type
		this[customizationType] = {
			value: isStandard ? undefined : value,
			price: isStandard ? 0 : price,
			...(isEngravingForm
				? { font: selectedInputs[0].value || undefined }
				: {}),
			...(customizationType === 'design_adjustments'
				? this.getDesignAdjustmentSelections(form)
				: {}),
		}

		// Close the modal (assuming you're using the cc-modal system)
		const modal = form.closest('.cc-modal-window')
		if (modal) {
			const closeButton = modal.querySelector('.cc-modal-window__close')
			if (closeButton) {
				closeButton.click()
			}
		}

		// Trigger customization change
		this.customizationChanged()
	}

	getDesignAdjustmentSelections(form) {
		const selectedInputs = Array.from(
			form.querySelectorAll('input[type="radio"]:checked'),
		).filter((input) => !input.value.toLowerCase().includes('standard'))

		return {
			selections: Object.fromEntries(
				selectedInputs.map((input) => [input.name, input.value]),
			),
			keywords: selectedInputs
				.map((input) => input.dataset.variantKeyword)
				.filter(Boolean),
			propertyValue:
				selectedInputs
					.filter((input) => !input.dataset.variantKeyword)
					.map((input) => input.value)
					.join(', ') || undefined,
		}
	}

	handleConfirmationModalOpen = (modal) => {
		const customizationConfirmations = modal.querySelector(
			'[data-customizations-confirmation]',
		)
		const standardVariantTitle = modal.querySelector(
			'[data-standard-variant-title]',
		)
		const customizationExtras = modal.querySelector(
			'[data-customization-extras]',
		)
		const engraving = modal.querySelector(
			'[data-customizations-confirmation-item="engraving"]',
		)

		const selectedDeliveryTimeText = document.querySelector(
			'[data-customization-pick="delivery"]',
		)?.textContent

		let variantTitle = this.selectedVariant.options.join(' | ')

		const isSpecialVariant = this.isSpecialVariant(this.selectedVariant)
		if (isSpecialVariant) {
			variantTitle = this.selectedVariant.options
				.slice(this.upgradeOptionsIndex)
				.join(' | ') // Avoid displaying the defaults
			if(this.upgradeOptionIsSizeSelector){
				variantTitle = variantTitle += ` | Størrelse ${this.size}`
			}
		}

		standardVariantTitle.textContent =
			variantTitle ?? standardVariantTitle.textContent

		customizationExtras.innerHTML = ''
		engraving.classList.add('hidden')
		// Adjustments with a variant keyword are already part of the variant title
		if (this.design_adjustments.propertyValue) {
			customizationExtras.innerHTML += ` | ${this.design_adjustments.propertyValue}`
		}

		if (this.gift.value) {
			customizationConfirmations.classList.remove('hidden')
			customizationConfirmations
				.querySelector(
					'li[data-customizations-confirmation-item="gift"]',
				)
				.classList.remove('hidden')
		} else {
			customizationConfirmations
				.querySelector(
					'li[data-customizations-confirmation-item="gift"]',
				)
				.classList.add('hidden')
		}
		if (selectedDeliveryTimeText) {
			customizationConfirmations.querySelector(
				'li[data-customizations-confirmation-item="delivery"]',
			).textContent = selectedDeliveryTimeText
		}

		if (this.engraving.value) {
			customizationConfirmations.classList.remove('hidden')
			engraving.classList.remove('hidden')
			const span = engraving.querySelector('span')
			span.textContent = this.engraving.value
			if (this.engraving.font) {
				span.style.fontFamily = this.engraving.font
			} else {
				span.style.fontFamily = 'inherit'
			}
		}
	}

	hideDeliveryOption = () => {
		const inventoryStatus = document.querySelector(
			'[data-inventory-status]',
		)
		inventoryStatus?.classList.remove('hidden')
		const deliveryOptionElements = this.querySelectorAll(
			'[data-customization-label="gift"], [data-customization-pick="gift"], [data-customization-actions="gift"], [data-customization-label="delivery"], [data-customization-pick="delivery"], [data-customization-actions="delivery"]',
		)
		if (
			Array.from(deliveryOptionElements).every((element) =>
				element.classList.contains('!hidden'),
			)
		)
			return
		deliveryOptionElements.forEach((element) => {
			element.classList.add('!hidden')
		})
		this.resetCustomization('delivery')
		this.resetCustomization('gift')
	}

	showDeliveryOption = () => {
		const deliveryOptionElements = this.querySelectorAll(
			'[data-customization-label="gift"], [data-customization-pick="gift"], [data-customization-actions="gift"], [data-customization-label="delivery"], [data-customization-pick="delivery"], [data-customization-actions="delivery"]',
		)
		deliveryOptionElements.forEach((element) => {
			element.classList.remove('!hidden')
		})
		const inventoryStatus = document.querySelector(
			'[data-inventory-status]',
		)
		inventoryStatus?.classList.add('hidden')
	}

	// Add engraving attributes as a hidden form input
	addEngravingAttributes = () => {
		this.removeEngravingAttributes()
		const form = document.querySelector(
			`form.product-purchase-form[data-product-id="${this.productId}"]`,
		)

		const engravingFontInput = document.createElement('input')
		engravingFontInput.type = 'hidden'
		engravingFontInput.name =
			DiamondCustomizations.ENGRAVING_FONT_PROPERTY_NAME
		engravingFontInput.value = this.engraving.font || ''
		form.appendChild(engravingFontInput)

		const engravingTextInput = document.createElement('input')
		engravingTextInput.type = 'hidden'
		engravingTextInput.name = DiamondCustomizations.ENGRAVING_PROPERTY_NAME
		engravingTextInput.value = this.engraving.value || ''
		form.appendChild(engravingTextInput)
	}

	removeEngravingAttributes = () => {
		const form = document.querySelector(
			`form.product-purchase-form[data-product-id="${this.productId}"]`,
		)
		const engravingInputs = form.querySelectorAll(
			`input[name="${DiamondCustomizations.ENGRAVING_PROPERTY_NAME}"], input[name="${DiamondCustomizations.ENGRAVING_FONT_PROPERTY_NAME}"]`,
		)
		engravingInputs.forEach((input) => {
			form.removeChild(input)
		})
	}

	// Add size attribute as a hidden form input
	addSizeAttribute = () => {
		this.removeSizeAttribute()
		const sizeInput = document.createElement('input')
		sizeInput.type = 'hidden'
		sizeInput.name = DiamondCustomizations.SIZE_PROPERTY_NAME
		sizeInput.value = this.size
		const form = document.querySelector(
			`form.product-purchase-form[data-product-id="${this.productId}"]`,
		)
		form.appendChild(sizeInput)
	}

	removeSizeAttribute = () => {
		const form = document.querySelector(
			`form.product-purchase-form[data-product-id="${this.productId}"]`,
		)
		const sizeInput = form.querySelector(
			`input[name="${DiamondCustomizations.SIZE_PROPERTY_NAME}"]`,
		)
		if (sizeInput) {
			form.removeChild(sizeInput)
		}
	}

	addDesignAdjustmentsAttributes = () => {
		this.removeDesignAdjustmentsAttributes()
		const adjustmentsInput = document.createElement('input')
		adjustmentsInput.type = 'hidden'
		adjustmentsInput.name =
			DiamondCustomizations.DESIGN_ADJUSTMENTS_PROPERTY_NAME
		adjustmentsInput.value = this.design_adjustments.propertyValue || ''
		const form = document.querySelector(
			`form.product-purchase-form[data-product-id="${this.productId}"]`,
		)
		form.appendChild(adjustmentsInput)
	}

	removeDesignAdjustmentsAttributes = () => {
		const form = document.querySelector(
			`form.product-purchase-form[data-product-id="${this.productId}"]`,
		)
		const adjustmentsInput = form.querySelector(
			`input[name="${DiamondCustomizations.DESIGN_ADJUSTMENTS_PROPERTY_NAME}"]`,
		)
		if (adjustmentsInput) {
			form.removeChild(adjustmentsInput)
		}
	}

	// Finds the special variant containing exactly the given upgrade values (metal, diamond, adjustment keywords), in
	// any order. For example Specialbestilling | 14kt. | D/VVS1
	findSpecialVariantByOptions = (...upgradeValues) => {
		const values = upgradeValues.filter(Boolean)
		if (!values.length) return this.findBaseSpecialVariant()
		return this.variants.find((variant) => {
			const upgradeOption = variant.options[this.upgradeOptionsIndex]
			if (!upgradeOption) return false
			const variantTitleParts = upgradeOption
				.split('|')
				?.map((p) => p.trim())
			if (DiamondCustomizations.DEBUG) {
				console.log(
					'[UPGRADES] - Parts:',
					variantTitleParts,
					'upgradeValues:',
					values,
				)
			}

			// If only a single upgrade is applied, look only in the variants that applies a single upgrade
			// For example Specialbestilling | D/VVS1
			const matchesNumberOfValues =
				values.length === variantTitleParts.length - 1

			return (
				matchesNumberOfValues &&
				values.every((value) => upgradeOption.includes(value))
			)
		})
	}

	findSelectedSpecialVariant = (overrides = {}) => {
		const { metal, diamond, keywords } = {
			metal: this.metal.value,
			diamond: this.diamond.value,
			keywords: this.design_adjustments.keywords,
			...overrides,
		}
		return this.findSpecialVariantByOptions(metal, diamond, ...keywords)
	}

	// Disables the upgrade options that would lead to a special variant that does not exist or is unavailable, given
	// the other selected upgrades. Standard options are never disabled.
	// Note: The modals copy the innerHTML of the hidden forms when opened, so an open modal has its own copy of the form
	updateOptionAvailability = () => {
		;['metal', 'diamond'].forEach((type) => {
			document
				.querySelectorAll(
					`form[data-customization-form="${type}"][data-product-id="${this.productId}"] input[type="radio"]`,
				)
				.forEach((input) => {
					if (input.value.toLowerCase().includes('standard')) return
					this.setOptionAvailability(
						input,
						this.isSpecialVariantAvailable({ [type]: input.value }),
					)
				})
		})

		document
			.querySelectorAll(
				`form[data-customization-form="design_adjustments"][data-product-id="${this.productId}"]`,
			)
			.forEach((form) =>
				this.updateDesignAdjustmentAvailability(
					form,
					this.design_adjustments.selections,
				),
			)
	}

	updateDesignAdjustmentAvailability = (form, selections) => {
		const keywordInputs = Array.from(
			form.querySelectorAll('input[type="radio"][data-variant-keyword]'),
		)
		keywordInputs.forEach((input) => {
			// Combine with the keywords selected in the other adjustments, which leaves no matching variant if another
			// variant-based adjustment is already selected
			const otherKeywords = keywordInputs
				.filter(
					(other) =>
						other.name !== input.name &&
						selections[other.name] === other.value,
				)
				.map((other) => other.dataset.variantKeyword)
			this.setOptionAvailability(
				input,
				this.isSpecialVariantAvailable({
					keywords: [...otherKeywords, input.dataset.variantKeyword],
				}),
			)
		})
	}

	isSpecialVariantAvailable = (overrides) =>
		!!this.findSelectedSpecialVariant(overrides)?.available

	setOptionAvailability = (input, isAvailable) => {
		input.disabled = !isAvailable
		input.classList.toggle('is-unavailable', !isAvailable)
	}

	// The variant currently selected in the product form, i.e. the one that will be added to the cart
	getFormVariant = () => {
		const variantId = document.querySelector(
			`form.product-purchase-form[data-product-id="${this.productId}"] [name="id"]`,
		)?.value
		return this.variants.find((variant) => String(variant.id) === variantId)
	}

	// Finds the variant matching the selected size. The other options (e.g. width, karat, thickness) are kept from the
	// reference variant, so we don't jump to the first variant of the size. Falls back to the first size match.
	findSizeMatchedVariant = (referenceVariant) => {
		const sizeMatchedVariants = this.variants.filter(
			(variant) => variant.options[this.upgradeOptionsIndex] === this.size,
		)
		if (!referenceVariant) return sizeMatchedVariants[0]
		return (
			sizeMatchedVariants.find((variant) =>
				variant.options.every(
					(value, i) =>
						i === this.upgradeOptionsIndex ||
						value === referenceVariant.options[i],
				),
			) || sizeMatchedVariants[0]
		)
	}

	findDefaultVariant = () => {
		return this.variants.find((variant) =>
			DiamondCustomizations.DEFAULT_VARIANTS.some((defaultVariant) =>
				variant.options[this.upgradeOptionsIndex]?.includes(
					defaultVariant,
				),
			),
		)
	}

	findBaseSpecialVariant = () => {
		return this.variants.find((variant) => {
			return (
				DiamondCustomizations.SPECIAL_VARIANTS.some((special) =>
					variant.options[this.upgradeOptionsIndex]?.includes(special),
				) && !variant.options[this.upgradeOptionsIndex]?.includes('|')
			)
		})
	}

	isSpecialVariant = (variant) => {
		if (DiamondCustomizations.DEBUG) {
			console.info(
				'[UPGRADES] - Checking if variant is one of special variants',
				DiamondCustomizations.SPECIAL_VARIANTS,
				variant,
			)
		}
		return DiamondCustomizations.SPECIAL_VARIANTS.some((special) =>
			variant?.options[this.upgradeOptionsIndex]?.includes(special),
		)
	}

	updateModalInputs = (form, contentType) => {
		const modalInputs = form.querySelectorAll('input[type="radio"]')
		const modalTextAreas = form.querySelectorAll('textarea')

		modalInputs.forEach((input, index) => {
			let shouldCheck
			if (contentType === 'engraving') {
				shouldCheck = this.shouldCheckEngravingInput(input, index)
			} else if (contentType === 'design_adjustments') {
				shouldCheck = this.shouldCheckDesignAdjustmentInput(input)
			} else {
				shouldCheck = this.shouldCheckStandardInput(input, contentType)
			}

			input.checked = shouldCheck
			if (shouldCheck) {
				input.setAttribute('checked', 'checked')
			} else {
				input.removeAttribute('checked')
			}
		})

		modalTextAreas.forEach((textarea) => {
			textarea.value = this.engraving.value || ''
			textarea.textContent = this.engraving.value || ''
		})
	}

	shouldCheckEngravingInput = (input, index) => {
		if (!this.engraving.font && index === 0) return true
		if (this.engraving.font && input.value === this.engraving.font)
			return true
		return false
	}

	shouldCheckStandardInput = (input, contentType) => {
		return (
			(!this[contentType].value &&
				input.value.toLowerCase().includes('standard')) ||
			input.value === this[contentType].value
		)
	}

	shouldCheckDesignAdjustmentInput = (input) => {
		const selection = this.design_adjustments.selections[input.name]
		if (selection) return input.value === selection
		return input.value.toLowerCase().includes('standard')
	}

	initializeMade2Order = () => {
		if (!window.Made2Order) {
			window.Made2Order = { additionalItemsToAdd: [] }
		}

		if (!window.Made2Order.additionalItemsToAdd) {
			window.Made2Order.additionalItemsToAdd = []
		}
	}

	addItemToMade2Order = (itemId, variant) => {
		if (!itemId) return

		this.initializeMade2Order()

		const item = {
			id: itemId,
			quantity: 1,
			properties: {
				_for:
					this.productData.title + ' ' + variant?.title,
			},
		}

		// Remove existing item with same ID to prevent duplicates
		window.Made2Order.additionalItemsToAdd =
			window.Made2Order.additionalItemsToAdd
				.filter((existingItem) => existingItem.id !== itemId)
				.concat(item)
	}

	removeItemFromMade2Order = (itemId) => {
		if (!itemId || !window.Made2Order?.additionalItemsToAdd) return

		window.Made2Order.additionalItemsToAdd =
			window.Made2Order.additionalItemsToAdd.filter(
				(item) => item.id !== itemId,
			)
	}

	manageMade2OrderItems = (newVariant) => {
		// Handle delivery item
		if (this.delivery.value) {
			this.addItemToMade2Order(this.delivery.value, newVariant)
		} else {
			this.removeItemFromMade2Order(this.delivery.value)
		}

		// Handle gift item
		if (this.gift.value) {
			this.addItemToMade2Order(this.gift.value, newVariant)
		} else {
			this.removeItemFromMade2Order(this.gift.value)
		}
	}

	customizationChanged(
		config = {
			default_variant: null,
		},
	) {
		if (DiamondCustomizations.DEBUG) {
			console.log('[UPGRADES] - Customizations changed', {
				size: this.size,
				metal: this.metal,
				diamond: this.diamond,
				adjustments: this.design_adjustments,
				engraving: this.engraving,
				delivery: this.delivery,
				gift: this.gift,
				variants: this.variants,
				default_variant: config.default_variant,
			})
		}

		let newVariant = null

		const canUseDefaultVariant =
			!this.metal.value &&
			!this.diamond.value &&
			!this.design_adjustments.keywords.length
		if (canUseDefaultVariant) {
			// Pick the normal variant, or the one that matches size and the other selected options.
			const defaultVariant =
				config.default_variant &&
				config.default_variant.options[this.upgradeOptionsIndex] ===
					this.size
					? config.default_variant
					: null
			const sizeMatchedVariant = this.findSizeMatchedVariant(
				this.getFormVariant() || this.selectedVariant,
			)
			if (DiamondCustomizations.DEBUG) {
				console.log(
					'[UPGRADES] - Size matched variant:',
					sizeMatchedVariant,
				)
			}
			// If no size matched variant is found, we assume it is a special size.
			// Therefore we look for the base special variant and pick that.
			// We fall back to the default variant if no base special variant is found.
			newVariant =
				defaultVariant ||
				sizeMatchedVariant ||
				this.findBaseSpecialVariant() ||
				this.findDefaultVariant()
		} else {
			// If any customization is selected, find the special variant that matches
			if (DiamondCustomizations.DEBUG) {
				console.log(
					'[UPGRADES] - Finding special variant for customizations:',
					{
						metal: this.metal,
						diamond: this.diamond,
						adjustments: this.design_adjustments,
					},
				)
			}

			newVariant = this.findSelectedSpecialVariant()
		}

		if (DiamondCustomizations.DEBUG) {
			console.log('[UPGRADES] - New variant:', newVariant)
		}

		if (!newVariant) {
			console.warn(
				'[UPGRADES] - Hiding upgrade component: No matching variant found for the current customizations:',
				{
					size: this.size,
					metal: this.metal,
					diamond: this.diamond,
					engraving: this.engraving,
					delivery: this.delivery,
				},
			)
			this.hideUpgradeComponent()
			return
		}

		if (newVariant.inventory_quantity > 0) {
			this.hideDeliveryOption()
		} else {
			this.showDeliveryOption()
		}

		if (this.engraving.value) {
			this.addEngravingAttributes()
		} else {
			this.removeEngravingAttributes()
		}

		if (this.design_adjustments.propertyValue) {
			this.addDesignAdjustmentsAttributes()
		} else {
			this.removeDesignAdjustmentsAttributes()
		}

		// Manage size attribute based on variant type
		if (this.isSpecialVariant(newVariant) && this.size && this.upgradeOptionIsSizeSelector) {
			this.addSizeAttribute()
		} else {
			this.removeSizeAttribute()
		}

		// Manage Made2Order items (delivery and gift)
		this.manageMade2OrderItems(newVariant)

		// Remove all emulated checked states
		const emulatedCheckedInputs = this.getSizeSelectors()?.querySelectorAll(
			'.opt-btn-emulate-checked:not([data-picked-size])',
		)
		emulatedCheckedInputs?.forEach((input) => {
			input.classList.remove('opt-btn-emulate-checked')
		})
		const pickedSizeElement =
			this.getSizeSelectors()?.querySelector('[data-picked-size]')

		if (
			pickedSizeElement &&
			pickedSizeElement.dataset.pickedSize === this.size
		) {
			pickedSizeElement.classList.remove('hidden')
			pickedSizeElement.querySelector('.opt-label__text').textContent =
				this.size
		} else if (pickedSizeElement) {
			pickedSizeElement.classList.add('hidden')
			pickedSizeElement.querySelector('.opt-label__text').textContent = ''
		} else {
			console.warn('No picked size element found in the size selectors.')
		}

		// Find the option input for the option1 and click it to trigger the default theme variant change behavior
		// If it's a special customization, this will pick one of the hidden special variants
		const matchingInput = this.getUpgradeSelectors()?.querySelector(
			`input[value="${newVariant.options[this.upgradeOptionsIndex]}"]`,
		)
		console.info('Matching input for variant:', matchingInput)
		if (matchingInput && !matchingInput.checked) {
			setTimeout(() => {
				matchingInput.click()
			})
		}

		this.selectedVariant = newVariant

		// Also emulate a checked state on the option that matches the size, by adding the class .opt-emulate-checked to the input
		const sizeMatchedInput =
			this.size &&
			this.getSizeSelectors()?.querySelector(
				`input[value="${this.size}"]:not([data-custom-size-modal-option])`,
			)
		if (sizeMatchedInput) {
			sizeMatchedInput.classList.add('opt-btn-emulate-checked')
		}

		// Update modal option defaults
		const modalForms = document.querySelectorAll(
			'form[data-customization-form]',
		)
		modalForms.forEach((form) => {
			const contentType = form.getAttribute('data-customization-form')
			this.updateModalInputs(form, contentType)
		})
		this.updateOptionAvailability()

		this.updateCombinedPrice()
		this.updateDisplays()
		this.updateComponentVisibility()
	}

	updateCombinedPrice() {
		// If variant price is more than minimum price, update the customization price area to show the difference
		const priceArea = this.querySelector('[data-total-price]')
		const includeVariantPrice =
			priceArea.dataset.includeVariantPrice === 'true'
		let variantUpgradePrice = 0
		if (includeVariantPrice) {
			const cheapestVariantPrice = this.productData.price_min
			const selectedVariantPrice = this.selectedVariant.price
			variantUpgradePrice = selectedVariantPrice - cheapestVariantPrice
		}

		const total = this.delivery.price + variantUpgradePrice
		if (total > 0) {
			const formattedDifference = theme.Shopify.formatMoney(
				total,
				theme.money_format_with_cart_code_preference,
			)
			priceArea.innerHTML = `+${formattedDifference}`
		} else {
			priceArea.innerHTML = ''
		}
	}

	updateDisplays() {
		const selectionDisplays = this.querySelectorAll(
			'[data-customization-pick]',
		)
		const customizationActions = this.querySelectorAll(
			'[data-customization-actions]',
		)
		selectionDisplays.forEach((display) => {
			const customizationType = display.getAttribute(
				'data-customization-pick',
			)
			if (!this[customizationType]) {
				console.warn(
					`Customization type "${customizationType}" is not defined in the component.`,
				)
				return
			}

			let value = this[customizationType].value

			if (value) {
				display.classList.remove('opacity-75')
			} else {
				display.classList.add('opacity-75')
			}
			if (customizationType === 'engraving') {
				if (value) {
					display.style.fontFamily =
						this.engraving.font ?? 'Times New Roman'
					display.classList.remove('italic')
				} else {
					display.style.fontFamily = 'inherit'
					display.classList.add('italic')
				}
			}

			if (customizationType === 'delivery') {
				display.innerHTML = value
					? display.getAttribute('data-selected-text')
					: display.getAttribute('data-default-text')

				return
			}

			if (customizationType === 'gift') {
				display.innerHTML = value
					? display.getAttribute('data-selected-text')
					: display.getAttribute('data-default-text')

				return
			}

			if (value) {
				// Engraving is free text typed by the customer, so it must not be parsed as HTML
				display.textContent = value
			} else {
				display.innerHTML = display.getAttribute('data-default-text')
			}
		})

		// Update the visibility of upgrade buttons if a customization is selected
		customizationActions.forEach((action) => {
			const customizationType = action.getAttribute(
				'data-customization-actions',
			)
			if (!this[customizationType]) {
				console.warn(
					`Customization type "${customizationType}" is not defined in the component.`,
				)
				return
			}
			const value = this[customizationType].value
			const price = this[customizationType].price
			const upgradeButton = action.querySelector('a')
			const selectionDisplay = action.querySelector(
				'[data-selection-display]',
			)
			const priceDisplay = selectionDisplay.querySelector('[data-price]')
			if (value) {
				const formattedPrice = theme.Shopify.formatMoney(
					price,
					theme.money_format_with_cart_code_preference,
				)
				upgradeButton.classList.add('hidden')
				selectionDisplay.classList.remove('hidden')
				selectionDisplay.classList.add('flex')
				priceDisplay.textContent = price > 0 ? formattedPrice : ''
			} else {
				upgradeButton.classList.remove('hidden')
				selectionDisplay.classList.add('hidden')
				selectionDisplay.classList.remove('flex')
				priceDisplay.textContent = ''
			}
		})
	}

	resetCustomization(customizationType) {
		if (!this[customizationType]) {
			console.warn(
				`Customization type "${customizationType}" is not defined in the component.`,
			)
			return
		}
		const isEngraving = customizationType === 'engraving'
		const isDesignAdjustments = customizationType === 'design_adjustments'
		this[customizationType] = {
			value: undefined,
			price: 0,
			...(isEngraving ? { font: undefined } : {}),
			...(isDesignAdjustments
				? { selections: {}, keywords: [], propertyValue: undefined }
				: {}),
		}
		this.customizationChanged()
	}
}
const waitForJquery = (callback) => {
	if (window.jQuery) {
		callback()
	} else {
		setTimeout(() => waitForJquery(callback), 100)
	}
}

class CustomSize extends HTMLElement {
	constructor() {
		super()
		this.abortController = new AbortController()
	}

	connectedCallback() {
		this.setupCustomizationFormHandlers()
	}

	disconnectedCallback() {
		this.abortController.abort()
	}

	setupCustomizationFormHandlers() {
		// Use event delegation to handle form submissions for forms that might be dynamically added
		document.addEventListener(
			'input',
			(event) => {
				const form = event.target?.closest(
					'form[data-custom-size-form]',
				)
				if (!form) return
				const inStockInfo = form.querySelector('[data-in-stock-info]')
				const specialSizeInfo = form.querySelector(
					'[data-special-order-info]',
				)
				const orderableInfo = form.querySelector(
					'[data-orderable-info]',
				)
				const selectedInput = form.querySelector(
					'input[type="radio"]:checked',
				)
				inStockInfo.classList.add('hidden')
				specialSizeInfo.classList.add('hidden')
				orderableInfo.classList.add('hidden')
				if (selectedInput.hasAttribute('data-in-stock')) {
					inStockInfo.classList.remove('hidden')
					return
				}
				if (selectedInput.hasAttribute('data-custom-size')) {
					specialSizeInfo.classList.remove('hidden')
					return
				}
				orderableInfo.classList.remove('hidden')
			},
			{ signal: this.abortController.signal },
		)

		const handleSizeFormSubmit = (form) => {
			const selectedInput = form.querySelector(
				'input[type="radio"]:checked',
			)
			if (!selectedInput) {
				console.warn('No size option selected in the form.')
				// close modal
				const modal = form.closest('.cc-modal-window')
				modal?.querySelector('.cc-modal-window__close')?.click()
				return
			}
			const modal = form.closest('.cc-modal-window')
			modal?.querySelector('.cc-modal-window__close')?.click()

			const customizationElement =
				document.querySelector('d-customizations')
			if (!customizationElement) {
				console.warn('Customization element not found.')
				return
			}
			const isCustomSize = selectedInput.hasAttribute('data-custom-size')
			const pickedSizeButton = this.querySelector('[data-picked-size]')
			const size = selectedInput.value
			if (isCustomSize) {
				// Show the custom size on the button
				pickedSizeButton.classList.remove('hidden')
				pickedSizeButton.querySelector('.opt-label__text').textContent =
					size
				pickedSizeButton.dataset.pickedSize = selectedInput.value
			} else {
				// Hide the custom size button
				pickedSizeButton.classList.add('hidden')
			}
			customizationElement.size = size
			customizationElement.customizationChanged()
		}

		document.addEventListener(
			'submit',
			(event) => {
				const form = event.target
				if (form.matches('form[data-custom-size-form]')) {
					event.preventDefault()
					handleSizeFormSubmit(form)
				}
			},
			{ signal: this.abortController.signal },
		)

		document.addEventListener(
			'click',
			(event) => {
				if (!(event.target instanceof HTMLElement)) return
				if (!event.target.closest('.cc-modal-window__background'))
					return
				const modal = event.target.closest('.cc-modal-window')
				if (!modal) return
				const form = modal.querySelector('form[data-custom-size-form]')
				if (!form) return
				if (form.matches('form[data-custom-size-form]')) {
					event.preventDefault()
					handleSizeFormSubmit(form)
				}
			},
			{ signal: this.abortController.signal },
		)
	}
}

waitForJquery(() => {
	customElements.define('d-customizations', DiamondCustomizations)
	customElements.define('custom-size', CustomSize)
})
